module.exports = __webpack_public_path__ + "img/Remanufacturing1.9b8bcc6b.png";